import { createApp } from "vue";
import App from "./App.vue";
import { i18n } from "./plugins/i18n";
import getLocale from "./locale";
import {createHead} from "@vueuse/head";

const locale_config = getLocale();
i18n.global.locale = locale_config;

const head = createHead();

createApp(App).use(i18n).use(head).mount("#app");
